import { LEVEL_WEIGHTS, MESSAGE_AUTH_CODES } from "constant/messages";

const sortByMessageLevelAsc = sortByMessageLevel.bind(null, "asc");

function sortByMessageLevel(direction, m1, m2) {
  const multiplier = direction === "asc" ? 1 : -1;

  const w1 = LEVEL_WEIGHTS[m1.level];
  const w2 = LEVEL_WEIGHTS[m2.level];

  if (w1 > w2) {
    return multiplier;
  }

  if (w1 < w2) {
    return -1 * multiplier;
  }

  // Older messages by desc
  if (m1.created > m2.created) {
    return -1;
  }

  if (m1.created < m2.created) {
    return 1;
  }

  return 0;
}

function getPrioritizedUserMessages(messages) {
  return messages
    .filter((m) => {
      // Filter out auth messages
      return !MESSAGE_AUTH_CODES.includes(m.statusCode);
    })
    .sort(sortByMessageLevelAsc);
}

export { getPrioritizedUserMessages, sortByMessageLevel };
